// extracted by mini-css-extract-plugin
export default {"root":"Reveal_root__AFttz","visible":"Reveal_visible__+dmZC"};